import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { useSelector } from "react-redux";
import {
  connectWebSocket,
  listenToEvent,
  disconnectWebSocket,
} from "../payment/webSocketService";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import razorpayicon from "../../assets/razorpay-icon 1.jpg";
import powerPointLogo from "../../assets/PowerPoint logo.jpg";
import googleSlidesLogo from "../../assets/Google Slide logo.png";
import { AnimatePresence, motion } from "framer-motion";
import { getStaticPricing } from "../../utils/pricingConfig";
interface PricingModalNewProps {
  closeModal: () => void;
  currency: string;
  exportButtonText: string;
  exportButtonBundleText: string;
  exportHandler: () => void;
  setIsBundle: React.Dispatch<React.SetStateAction<boolean>>;
  savings?: string;
  exportType: "pdf" | "pptx";
  isUnlock:boolean;
  monthlyPlanAmount: number
  yearlyPlanAmount: number
  monthlyPlanId: string
  yearlyPlanId: string
   authToken: string
  orgId: string
  subscriptionId: string
}
interface PaymentData {
  
  [key: string]: any
}

interface SubscriptionData {
 
  [key: string]: any
}
const testimonials = [
  {
    message:
      "Zynth helped us save hours on presentation content and design. The exports are clean and investor-friendly.",
    name: "Anuj, Co-founder, Skale",
  },
  {
    message: "Used Zynth for my YC deck - clean, fast, and totally worth it.",
    name: "Priya, Founder, CleanCart",
  },
  {
    message:
      "The tool delivers excellent output, creating a well-structured and visually appealing pitch deck.",
    name: "Anthony Crosato",
  },
  {
    message:
      "The pitch deck created through Zynth app is excellent, providing a clear and professional presentation of our ideas.",
    name: "Hitesh Mittal, Founder, Hitech Enviro",
  },
];

export const PricingModalNew: React.FC<PricingModalNewProps> = ({
  closeModal,
  currency,
  exportButtonText,
  exportButtonBundleText,
  exportHandler,
  setIsBundle,
  savings,
  exportType,
  isUnlock,
  subscriptionId,
  monthlyPlanAmount,
  yearlyPlanAmount,
  yearlyPlanId,
  monthlyPlanId,
  authToken,
  orgId
}) => {
  const [isloading, setIsLoading] = useState(false)
  const [billingCycle, setBillingCycle] = useState<'monthly' | 'annual'>(
      'monthly'
    )
  const userPlan = useSelector((state: any) => state.user.userPlan);
  const userEmail = sessionStorage.getItem("userEmail");
  const displayCurrency = currency === "INR" ? "INR" : "USD";
  const pricing = getStaticPricing(displayCurrency);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(true);
  const [visibleKey, setVisibleKey] = useState(Date.now());
  

  useEffect(() => {
    const interval = setInterval(() => {
      let newIndex;
      do {
        newIndex = Math.floor(Math.random() * testimonials.length);
      } while (newIndex === currentIndex);
      setCurrentIndex(newIndex);
      setVisibleKey(Date.now());
    }, 3000);

    return () => clearInterval(interval);
  }, [currentIndex]);

  const { message, name } = testimonials[currentIndex];
    useEffect(() => {
      if (!orgId) {
        console.error('orgId is required to connect WebSocket')
        return
      }
  
      connectWebSocket(orgId)
     
      listenToEvent('payment.authorized', (data: PaymentData) => {
        console.log('Payment authorized:', data)
      })
  
      
      listenToEvent('subscription.authenticated', (data: SubscriptionData) => {
        console.log('Subscription authenticated:', data)
  
        window.location.reload()
      })
  
      // Cleanup WebSocket on unmount
      return () => {
        disconnectWebSocket()
      }
    }, [orgId])

 const handleUpgrade = async () => {
      setIsLoading(true)
      const planID = billingCycle === 'annual' ? yearlyPlanId : monthlyPlanId
      const currentTime = Date.now()
      const startAtTime = currentTime + 10 * 60 * 1000 // 10 minutes in milliseconds
      const startAtUnix = Math.floor(startAtTime / 1000) 
      const { message, name } = testimonials[currentIndex];// Convert to Unix timestamp in seconds
  
      if (userPlan === 'free') {
        try {
          const response = await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/payments/razorpay/create-subscription`,
            {
              plan_id: planID,
              customer_id: orgId,
              total_count: 12,
              start_at: startAtUnix,
              quantity: 1,
              orgId: orgId,
              userId: userEmail,
              notes: {
                OrgId: orgId,
              },
            },
            {
              headers: {
                Authorization: `Bearer ${authToken}`,
              },
            }
          )
  
          const result = await response.data
  
          if (result.short_url) {
            window.open(result.short_url, '_blank')
            setIsLoading(false)
          }
        } catch (error) {
          console.log(error)
          setIsLoading(false)
        }
      }
    }
  
    const handleCancel = async () => {
      setIsLoading(true)
  
      console.log('Sub ID: ', subscriptionId)
  
      if (userPlan !== 'free') {
        try {
          await axios
            .post(
              `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/payments/razorpay/cancel-subscription`,
              {
                subscription_id: subscriptionId,
                orgId: orgId,
              },
              {
                headers: {
                  Authorization: `Bearer ${authToken}`,
                },
              }
            )
            .then((response) => {
              if (response.status === 200) {
                window.location.reload()
              }
              setIsLoading(false)
            })
        } catch (error) {
          console.log(error)
          setIsLoading(false)
        }
      }
    }

  return (
    <div
      className={`${
        ![
          "/presentation-view",
          "/new-presentation",
          "/organization-profile",
          "/history",
          "/edit-organization-profile",
          "/refer",
        ].includes(window.location.pathname) &&
        !window.location.href.includes("/presentation-view?") &&
        !window.location.href.includes("#/history") &&
        !window.location.href.includes("#/refer") &&
        !window.location.href.includes("#/new-presentation") &&
        !window.location.href.includes("#/organization-profile") &&
        !window.location.href.includes("#/edit-organization-profile")
          ? "fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center"
          : "fixed top-0 left-0 w-screen h-screen z-50 bg-gray-800 bg-opacity-50 flex justify-center items-center"
      }`}
    >
      <div className="bg-white w-[95%] lg:w-[92%] xl:w-[70%] max-h-[95%] md:max-h-[100%] lg:max-h-[98%] overflow-y-auto scrollbar-none rounded-lg shadow-lg p-4 sm:p-6 relative mx-auto">
        <button
          onClick={closeModal}
          className="absolute top-2 right-2 sm:top-4 sm:right-4 text-gray-500 hover:text-gray-900 hover:scale-110 active:scale-95 transform transition text-lg md:text-4xl"
        >
          &times;
        </button>

        <div className="text-center">
          <p className="font-semibold text-2xl sm:text-3xl">
            {isUnlock?"UNLOCK ALL SLIDES AND DOWLOAD YOUR PRESENTATION": `YOUR ${exportType=="pdf"?"GOOGLE SLIDE":"POWERPOINT"}${" "}PRESENTATION IS${" "}`}
            
            <span className="text-blue-700">{isUnlock?"":"READY TO GO"}</span>
          </p>
          {(isUnlock ? (
            <p className="text-base mt-2 sm:text-lg">
              Unlock to view the full presentation. Access all slides, make edits, and export directly to Google Slides or Powerpoint.
            </p>
  
          )
          :
          (
             <p className="text-base mt-2 sm:text-lg">
            Export your{" "}
            <span className="italic font-semibold">
              professionally designed, fully editable deck in seconds
            </span>
          </p>
          ))
        }
         
        </div>

        <div className="flex flex-col md:flex-row w-full items-center justify-center gap-8 lg:gap-5 mt-4">
          <div className="relative bg-[linear-gradient(to_right,_#6885B38F,_#3667B2,_#071C3D)] w-full sm:w-[90%] md:w-[80%] lg:w-[48%] min-h-[300px] xl:min-h-[300px] rounded-3xl">
            <div className="absolute w-full h-full py-4 px-4">
              <button className="flex rounded-xl items-center justify-center bg-[#F5F9FF] w-[60%] sm:w-[40%] md:w-[50%]">
                <span className="text-blue-700 text-base sm:text-lg font-semibold">
                  SINGLE EXPORT
                </span>
              </button>
              <div className="mt-3 text-white">
                <p className="text-lg font-semibold">  {isUnlock?"Unlock All Slide and Slide Types":exportType=="pdf"?"Download and Sync to Goodle Slides":"Download Editable PowerPoint"}</p>
                <p className="text-3xl sm:text-4xl font-semibold font-sans">
                  {exportButtonText}/ Deck
                </p>
              </div>
              <hr className="border-t-2 border-dashed border-[#FFFFFF42] my-2 w-full" />

              <div className="flex flex-col gap-2">
                {/* For large screens – group into rows */}
                <div className="hidden lg:flex flex-col gap-2">
                  {(
                    isUnlock?
                    [
                        ["View & Edit All Slides"],
                        ["Editable Google Slides and PowerPoint"],
                        ["Unlock New Slide Types" ],
                        ["Auto Sync with Zynth"]
                    ]
                    :exportType == "pdf"
                    ? [
                        ["View & Edit All Slides"],
                        ["Editable Google Slides"],
                        ["Unlock New Slide Types" ],
                        ["Auto Sync with Zynth"]
                      ]
                    : [
                        ["View & Edit All Slides"],
                        ["Editable Powerpoint (PPTX)"],
                        ["Unlock New Slide Types"],
                        ["Lifetime Access"]
                      ]
                  ).map((row, rowIndex) => (
                    <div
                      key={rowIndex}
                      className={`flex flex-wrap ${
                        rowIndex === 1  ? exportType !== "pdf"? "gap-24":"gap-16" : rowIndex===2?exportType !== "pdf"?"gap-7":"gap-14":"gap-7"
                      } items-center`}
                    >
                      {row.map((text, i) => (
                        <div
                          key={i}
                          className={`flex items-center  ${
                            rowIndex === 1 && i === 1 ? "gap-2" : "gap-2"
                          }`}
                        >
                          <button title="Arrow" className="rounded-full flex bg-white w-5 h-5 items-center justify-center">
                            <FontAwesomeIcon
                              icon={faArrowRight}
                              className="text-blue-600 w-4 h-4"
                            />
                          </button>
                          <p className="text-white text-base font-semibold">
                            {text}
                          </p>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
                <div className="flex flex-col gap-1/2 lg:hidden">
                  {(
                     isUnlock?
                    [
                        "View & Edit All Slides",
                        "Editable Google Slides and PowerPoint",
                        "Unlock New Slide Types" ,
                        "Auto Sync with Zynth"
                    ]:
                    exportType == "pdf"
                    ? [
                       "View & Edit All Slides",
                        "Editable Google Slides",
                        "Unlock New Slide Types" ,
                        "Auto Sync with Zynth"
                      ]
                    : [
                        "View & Edit All Slides",
                        "Editable Powerpoint (PPTX)",
                        "Unlock New Slide Types",
                        "Lifetime Access"
                      ]
                  ).map((text, i) => (
                    <div key={i} className="flex items-center gap-2">
                      <button
                        title="button arrow"
                        className="rounded-full flex bg-white w-5 h-5 items-center justify-center"
                      >
                        <FontAwesomeIcon
                          icon={faArrowRight}
                          className="text-blue-600 w-4 h-4"
                        />
                      </button>
                      <p className="text-white text-base font-semibold">
                        {text}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <button
              id="export-now"
              disabled={isloading}
              onClick={() => {
                console.log("Cliked for single export");
                setIsBundle(false);
                setIsLoading(true)
                exportHandler();
                setIsLoading(false)
              }}
              className="absolute left-1/2 bottom-[-24px] transform -translate-x-1/2 bg-[#3667B2] text-white font-semibold px-6 py-2 rounded-full shadow-md"
            >
              {
                isloading?(
                   <div className="w-full h-full flex items-center justify-center">
                      <div className="w-7 h-7 border-4 border-t-blue-500 border-gray-300 rounded-full animate-spin"></div>
                  </div>
                ): (<p>Export Now</p>)  
              }
           
            </button>
          </div>

          <div className="relative bg-[#F5F9FF] w-full sm:w-[90%] md:w-[80%] lg:w-[45%] min-h-[300px] xl:min-h-[300px] border border-gray-700 rounded-3xl">
            <div className="absolute w-full h-full py-4 px-4">
              <button className="flex rounded-xl items-center justify-center bg-[radial-gradient(circle,_#6885B38F,_#3667B2,_#071C3D)] w-[70%] sm:w-[60%] md:w-[80%] lg:w-[70%]">
                <span className="text-white text-base sm:text-lg font-semibold">
                 ZYNTH PRO SUBSCRIPTION
                </span>
              </button>
              <div className="mt-3">
                <p className="text-black text-lg font-semibold">
                 Best Value (Popular Choice)
                </p>
                <p className="text-black text-3xl sm:text-4xl font-semibold font-sans">
                 {displayCurrency === "INR" ? "₹" : "$"} {monthlyPlanAmount}
                </p>
              </div>
              <hr className="border-t-2 border-dashed border-[#49699987] my-2 w-full" />
              <div className="flex flex-col justify-center gap-2">
                <div className="flex items-center gap-2">
                  <button className="rounded-full flex bg-[radial-gradient(circle,_#6885B38F,_#3667B2,_#071C3D)] w-5 h-5 items-center justify-center">
                    <FontAwesomeIcon
                      icon={faArrowRight}
                      className="text-white w-4 h-4"
                    />
                  </button>
                  <p className="text-black text-base font-semibold">
                   Unlimited Deck Generation
                  </p>
                </div>
                <div className="flex items-center gap-2">
                  <button className="rounded-full flex bg-[radial-gradient(circle,_#6885B38F,_#3667B2,_#071C3D)] w-5 h-5 items-center justify-center">
                    <FontAwesomeIcon
                      icon={faArrowRight}
                      className="text-white w-4 h-4"
                    />
                  </button>
                  <p className="text-black text-base font-semibold">
                    Unlimited Exports
                  </p>
                </div>
                <div className="flex items-center gap-2">
                  <button className="rounded-full flex bg-[radial-gradient(circle,_#6885B38F,_#3667B2,_#071C3D)] w-5 h-5 items-center justify-center">
                    <FontAwesomeIcon
                      icon={faArrowRight}
                      className="text-white w-4 h-4"
                    />
                  </button>
                  <p className="text-black text-base font-semibold">
                    Access to All Features
                  </p>
                </div>
                <div className="flex items-center gap-2">
                  <button className="rounded-full flex bg-[radial-gradient(circle,_#6885B38F,_#3667B2,_#071C3D)] w-5 h-5 items-center justify-center">
                    <FontAwesomeIcon
                      icon={faArrowRight}
                      className="text-white w-4 h-4"
                    />
                  </button>
                  <p className="text-black text-base font-semibold">
                     Priority Rendering + Support
                  </p>
                </div>
              </div>
            </div>

            

            <button
              id="get_the_bundle"
              onClick={async () => {
                // console.log("Cliked for Bundle export");
                //setIsBundle(true);      
                //exportHandler();
                userPlan === 'free' ? handleUpgrade() : handleCancel()
              }}
              disabled={isloading==true}
              className="absolute left-1/2 bottom-[-24px] transform -translate-x-1/2 bg-white text-blue-700 font-semibold px-6 py-2 rounded-full shadow-md hover:border-2 hover:border-blue-700"
            >
               {
                isloading?(
                  <div className="w-full h-full flex items-center justify-center">
                      <div className="w-7 h-7 border-4 border-t-blue-500 border-gray-300 rounded-full animate-spin"></div>
                  </div>
                  
                ): (userPlan === 'free' ? 'Upgrade to Pro' : 'Cancel Subscription')
              }
           
              
            </button>
          </div>
        </div>

        <div className="flex items-center justify-center mt-10">
          <div className="flex flex-col w-full sm:w-[90%] md:w-[70%] lg:w-[70%] xl:w-[60%]
           h-[30vh] sm:h-[30vh] md:h-[22vh] lg:h-[22vh] xl:h-[22vh]
          items-center justify-center border border-gray-500 rounded-xl px-4 py-4">
            <p
              className="text-lg italic text-gray-800 mb-2 text-center "
              style={{
                willChange: "opacity, transform, filter",
                backfaceVisibility: "hidden",
                perspective: "1000px",
              }}
            >
              {message}
            </p>
            <p
              className="text-sm font-semibold text-blue-700 self-start"
              style={{
                willChange: "opacity, transform, filter",
                backfaceVisibility: "hidden",
                perspective: "1000px",
              }}
            >
               {name}
            </p>
            <div className="flex items-center mt-2 justify-start gap-2 w-full">
              {[...Array(5)].map((_, i) => (
                <FontAwesomeIcon
                  key={i}
                  icon={faStar}
                  className="text-yellow-400 w-5 h-5"
                />
              ))}
            </div>
          </div>
        </div>

        <hr className="border-t-2 border-dashed border-[#49699987] my-3 w-full" />
<div className="flex w-full items-center justify-center gap-20 md:flex hidden">
          <div className="flex items-center justify-center gap-2">
            <p className="font-semibold text-lg sm:text-xl">
              Secure payments via
            </p>
            <img src={razorpayicon} alt="icon" className="h-8 w-auto" />
          </div>
          <div className="flex items-center justify-center gap-2">
            <p className="font-semibold text-lg sm:text-xl">Compatible with</p>
            {exportType == "pdf" ? (
              <img
                src={googleSlidesLogo}
                alt="Google Slides"
                className="h-12 w-[10vw]"
              />
            ) : (
              <img
                src={powerPointLogo}
                alt="PowerPoint"
                className="h-10 w-[10vw]"
              />
            )}
          </div>
        </div>
        <div className="flex flex-col w-full items-center justify-center gap-2 md:hidden">
          <div className="flex items-center justify-center gap-2">
            <p className="font-semibold text-lg sm:text-xl">
              Secure payments via
            </p>
            <img src={razorpayicon} alt="icon" className="h-8 w-auto" />
          </div>
          <div className="flex items-center justify-center gap-2">
            <p className="font-semibold text-lg sm:text-xl">Compatible with</p>
            {
            isUnlock?
            (
                <>
      <img
        src={googleSlidesLogo}
        alt="Google Slides"
        className="h-12 w-[20vw] max-w-[150px]"
      />
      <img
        src={powerPointLogo}
        alt="PowerPoint"
        className="h-12 w-[20vw] max-w-[150px]"
      />
    </>
            )
            :exportType == "pdf" ? (
              <img
                src={googleSlidesLogo}
                alt="Google Slides"
                className="h-12 w-[20vw]"
              />
            ) : (
              <img
                src={powerPointLogo}
                alt="PowerPoint"
                className="h-12 w-[20vw]"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
